import axiosInstance from "../../../utils/axiosConfig";
import React, { useEffect, useState } from "react";
import { noTransaction } from "../../../assets/images";
import { API_URL } from "../../../constant";
import { useAuth } from "../../../context/auth-context";
import { formatAmount } from "../../../utils/FormatPerson";
import CashbackDetailsModal from "./CashbackDetailsModal";

const CashbackPoolTable = ({ refetchCount, setRefetchCount }: any) => {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [cashbackSettings, setCashbackSettings] = useState<any | null>(null);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`${API_URL}api/admin/cashback`)
      .then((r: any) => {
        setCashbackSettings(r?.data?.data ?? r?.data ?? null);
        setLoading(false);
      })
      .catch((e: any) => {
        console.log(
          e?.response?.data?.message ?? "Failed to fetch cashback settings"
        );
        setLoading(false);
      });
  }, [isAuthenticated, refetchCount]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any | null>(null);

  const handleOpen = (row: any) => {
    setSelected({
      duration: String(row.label || "").toLowerCase(),
      targetAmount: row.targetAmount,
      cashbackAmount: row.cashbackAmount,
      status: row.status,
      createdAt: row.createdAt ?? null,
    });
    setOpenModal(true);
  };

  return (
    <div className="w-full  mt-12">
      {loading ? (
        <div className="lgss:flex hidden gap-5 w-full mt-8 px-4 ">
          <div className="relative w-full space-y-3 overflow-hidden  bg-[#5c6b73] bg-opacity-30 p-8 shadow before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r before:from-transparent before:via-white/40 hover:shadow-lg before:animate-[shimmer_1.3s_infinite]">
            <div className="h-36 w-full  bg-[#E7EBEE]"></div>

            <div className="grid grid-cols-6 gap-2 mt-4">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
            <div className="grid grid-cols-6 gap-2">
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
              <div className="h-8 w-full rounded-full bg-[#E7EBEE]"></div>
            </div>
          </div>
        </div>
      ) : (
        (() => {
          const periods = [
            { key: "weeklySettings", label: "Weekly" },
            { key: "monthlySettings", label: "Monthly" },
            { key: "yearlySettings", label: "Yearly" },
          ] as const;

          const rows = periods
            .map((p) => {
              const value = cashbackSettings?.[p.key];
              if (!value) return null;
              return {
                label: p.label,
                targetAmount: value?.targetAmount ?? 0,
                cashbackAmount: value?.cashbackAmount ?? 0,
                status: value?.status ?? "--",
                createdAt: value?.createdAt ?? null,
              };
            })
            .filter(Boolean) as Array<{
            label: string;
            targetAmount: number;
            cashbackAmount: number;
            status: string;
            createdAt: string | null;
          }>;

          if (!rows.length) {
            return (
              <div className="w-full flex flex-col justify-start h-full pt-12 items-center">
                <img src={noTransaction} alt="" />
                <h4 className="font-bold text-[#869AA9] pt-2">
                  No cashback settings
                </h4>
                <p className=" text-[#869AA9] pt-2 text-[12px]">
                  When available, cashback settings will show here
                </p>
              </div>
            );
          }

          return (
            <div>
              <div className="bg-[#0D0D0D] overflow-auto scrollbar-thumb-[#60B7F6] scrollbar-track-white   scrollbar-thin   w-full  ">
                <table className="w-full">
                  <thead>
                    <tr className="h-[56px] bg-[#1C2227] flex justify-start px-8  items-center ">
                      <th className="text-[#617889] gap-12 cursor-pointer mr-4 flex justify-start items-center text-[15px] w-2/12  whitespace-nowrap ">
                        Duration
                      </th>
                      <th className="text-[#617889] gap-12 cursor-pointer mr-4 flex justify-start items-center text-[15px] w-3/12  whitespace-nowrap ">
                        Target Amount
                      </th>
                      <th className="text-[#617889] gap-6 cursor-pointer  flex justify-start items-center text-[15px] w-3/12 mr-4  whitespace-nowrap ">
                        Cashback Amount
                      </th>
                      <th className="text-[#617889] text-[15px] w-2/12 mr-4 whitespace-nowrap text-left overflow-hidden">
                        Status
                      </th>
                      <th className="text-[#617889] gap-4 cursor-pointer flex mr-4 justify-start items-center text-[15px] w-2/12  whitespace-nowrap ">
                        Date Created
                      </th>
                    </tr>
                  </thead>

                  {rows.map((row, index) => {
                    const formattedDate = (() => {
                      if (!row.createdAt) return "--";
                      const date = new Date(row.createdAt);
                      const day = date.getDate();
                      const ordinalSuffix = (d: number) => {
                        switch (d) {
                          case 1:
                          case 21:
                          case 31:
                            return "st";
                          case 2:
                          case 22:
                            return "nd";
                          case 3:
                          case 23:
                            return "rd";
                          default:
                            return "th";
                        }
                      };
                      return `${date.toLocaleString("default", {
                        month: "short",
                      })} ${day}${ordinalSuffix(
                        day
                      )}, ${date.getFullYear()}, ${date.toLocaleString(
                        "default",
                        { hour: "numeric", minute: "numeric", hour12: true }
                      )}`;
                    })();

                    return (
                      <tbody key={index} className="cursor-pointer">
                        <tr
                          className="h-[56px] w-full flex justify-start  px-8  items-center"
                          onClick={() => handleOpen(row)}
                        >
                          <td className="text-white text-[15px] w-2/12 whitespace-nowrap capitalize mr-4 text-left overflow-hidden">
                            {row.label}
                          </td>
                          <td className="text-white text-[15px] w-3/12 whitespace-nowrap mr-4 text-left overflow-hidden">
                            ₦ {formatAmount(row.targetAmount)}
                          </td>
                          <td className="text-white text-[15px] w-3/12 whitespace-nowrap mr-4 text-left overflow-hidden">
                            ₦ {formatAmount(row.cashbackAmount)}
                          </td>
                          <td
                            className={`text-[13px] w-2/12 uppercase whitespace-nowrap mr-4 text-left overflow-hidden ${
                              (row.status || "").toLowerCase() === "ongoing"
                                ? "text-[#22c55e] font-bold "
                                : (row.status || "").toLowerCase() ===
                                  "inactive"
                                ? "text-[#ef4444] font-bold"
                                : "text-white font-bold "
                            }`}
                          >
                            {row.status}
                          </td>
                          <td className="text-white text-[15px] w-2/12 whitespace-nowrap mr-4 text-left overflow-hidden">
                            {formattedDate}
                          </td>
                        </tr>
                        <tr className="w-full">
                          <td className="mt-1 w-full h-[1px] bg-[#13181B]" />
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>
              {openModal && selected && (
                <CashbackDetailsModal
                  open={openModal}
                  onClose={() => setOpenModal(false)}
                  data={selected}
                  setRefetchCount={setRefetchCount}
                  onSaved={(updated) => {
                    setCashbackSettings((prev: any) => {
                      if (!prev) return prev;
                      const key = `${updated.duration}Settings`;
                      return {
                        ...prev,
                        [key]: {
                          ...(prev?.[key] || {}),
                          targetAmount: updated.targetAmount,
                          cashbackAmount: updated.cashbackAmount,
                          status: updated.status,
                        },
                      };
                    });
                  }}
                />
              )}
            </div>
          );
        })()
      )}
    </div>
  );
};

export default CashbackPoolTable;
